module.exports = __webpack_public_path__ + "static/img/healer.04b7499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/healer.png
// module id = 7ix9
// module chunks = 0